<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>TOKEN：</label>
                <el-input v-model="search_Obj.f_token" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>当前时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="token" label="TOKEN" sortable="custom"></el-table-column>
                <el-table-column prop="sys_time" label="系统时间" sortable="custom"></el-table-column>
                <el-table-column prop="cur_time" label="当前时间" sortable="custom"></el-table-column>
                <el-table-column prop="version" label="版本" sortable="custom"></el-table-column>
                <el-table-column prop="temp" label="温度" sortable="custom"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom"></el-table-column>
                <el-table-column prop="cpu" label="CPU" sortable="custom"></el-table-column>
                <el-table-column prop="storage_total" label="存储容量(GB)" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.storage_avail }}/{{ scope.row.storage_total }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Info
            width="600px"
            :id="model_id"
            title="查看盒子日志"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'mdhzLogList',
    mixins: [listutil],
    components: { Info, Btns, LabBtns},
    data() {
        return {
            m_name: '盒子日志',
            menu_id: 11000,
            list_url: "/api/admin/mdhzlog/list",
            search_Obj: {
                f_token: '',
                f_cur_time_s_date: '',
                f_cur_time_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/mdhzlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            dateRange: '',
            pagesize: 100,
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_cur_time_s_date = val[0]
                this.search_Obj.f_cur_time_e_date = val[1]
            }else{
                this.search_Obj.f_cur_time_s_date = ''
                this.search_Obj.f_cur_time_e_date = ''
            }
        },
    }
};
</script>